import React from 'react'
import { ICharacter } from '../../../../../../../../api/types/character'
import { Box } from '@mui/material'
import { BaseStats } from '../BaseStats/BaseStats'
import { CalculatedStats } from '../CalculatedStats/CalculatedStats'
import cx from 'classnames'
import { DamageStat } from '../DamageStat/DamageStat'

interface Props {
  char: ICharacter
  game_id?: number
  showChatTab?: () => void
  editable?: boolean
  onEditAttribute?: (name: string, newValue: string) => void
  className?: string
}

export const CharacterStats: React.FC<Props> = ({
  char,
  game_id,
  showChatTab,
  editable,
  onEditAttribute,
  className,
}) => {
  return (
    <Box
      sx={{ display: 'flex', justifyContent: 'space-between' }}
      className={cx(className && className)}
    >
      <Box sx={{ flexGrow: '1.4' }}>
        <BaseStats
          showChatTab={showChatTab}
          char={char}
          game_id={game_id}
          editable={editable}
          onEditAttribute={onEditAttribute}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: '1' }}>
        <CalculatedStats char={char} />

        <DamageStat
          char_id={char.id}
          game_id={game_id}
          title={'Obrażenia'}
          entries={Object.entries(char.damage || {})}
          showRollButton={true}
        />

        <DamageStat
          char_id={char.id}
          game_id={game_id}
          title={'Redukcja obrażeń'}
          entries={Object.entries(char.damage_reduction || {})}
        />
      </Box>
    </Box>
  )
}
